import { render, staticRenderFns } from "./GiftcardSearchList.vue?vue&type=template&id=20633134&scoped=true&"
import script from "./GiftcardSearchList.vue?vue&type=script&lang=js&"
export * from "./GiftcardSearchList.vue?vue&type=script&lang=js&"
import style0 from "./GiftcardSearchList.vue?vue&type=style&index=0&id=20633134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20633134",
  null
  
)

export default component.exports